import type { LogPayload } from "./types";

import { datadogEnv } from "./datadog-env";
import { getTagsFromPayload } from "./get-tags-from-payload";

function formatStructuredConsoleFallback(payloads: LogPayload[]): string {
  const { environment, service } = datadogEnv();

  return JSON.stringify(
    payloads.map((payload) => ({
      ddtags: getTagsFromPayload(payload),
      environment,
      level: payload.level ?? "info",
      message: payload.message,
      service: payload.service ?? service,
      ...(payload.data ? { extra_data: payload.data } : {}),
    })),
  );
}

export { formatStructuredConsoleFallback };
